<template>
  <div class="brief-container">
    <h1>院校简介:</h1>
    <div class="box">
      <div :data="dataList">
        <i class="el-icon-collection-tag">&nbsp;学校领导</i>
        <p>{{ dataList.leader }}</p>
        <i class="el-icon-collection-tag">&nbsp;学校简介</i>
        <p>{{ dataList.introduce }}</p>
        <i class="el-icon-collection-tag">&nbsp;周边环境</i>
        <p>{{ dataList.surroundings }}</p>
        <i class="el-icon-location">&nbsp;通讯地址</i>
        <p class="indent">{{ dataList.address }}</p>
        <i class="el-icon-phone">&nbsp;联系电话</i>
        <p class="indent">{{ dataList.telephone }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import schoolBrief from '../../api/configuration'
export default {
  name: 'SchoolBrief',
  data() {
    return {
      dataList: [], //当前页要展示的列表数据,
      schoolName: this.$route.query.schoolName
    }
  },
  methods: {
    getSchoolBrief() {
      schoolBrief.getSchoolBrief(this.schoolName).then(res => {
        this.dataList = res.list
      })
    }
  },
  directives: {
    title(el, binding) {
      document.title = el.dataset.title
    }
  },
  created() {
    this.getSchoolBrief()
  }
}
</script>

<style scoped>
p {
  font-family: 微软雅黑;
  font-size: 16px;
  color: #666;
  margin-top: 10px;
  line-height: 2;
  text-indent: 2em;
  margin: 10px 0;
}
i {
  margin-top: 20px;
  font-size: 22px;
}
.schoolName {
  margin: 10px;
  color: gray;
  font-weight: 300;
}
.schoolName i {
  margin-left: 5px;
  font-size: 28px;
  vertical-align: middle;
}
.indent {
  text-indent: 0;
}
</style>